import React from "react";
import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";

const DirectHires = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">Direct Hires</h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <Users className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Find permanent employees to join your team full-time.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Direct Hires service is designed to help you find the perfect
            permanent employees for your organization. We understand that
            building a strong, long-term team is crucial for your success, and
            we're here to make that process as smooth and effective as possible.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              We discuss your hiring needs and company culture
            </li>
            <li className="mb-2">
              Our expert recruiters source and screen top candidates
            </li>
            <li className="mb-2">
              We present you with a shortlist of qualified candidates
            </li>
            <li className="mb-2">
              You interview and select the best fit for your team
            </li>
            <li>We assist with the offer and onboarding process</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default DirectHires;
